

const CardActions = ({ actions = [] }) => {
    if (actions.length > 2) {
        return (
            <div className="mb-8 w-full max-w-full">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Ações Rápidas</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-full">
                    {actions.map((action, index) => {
                        const IconComponent = action.icon
                        return (
                            <button
                                key={action.id}
                                onClick={() => window.location.href = action.href}
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-left group quick-action animate-fade-in-scale w-full max-w-full overflow-hidden" style={{ animationDelay: `${index * 150}ms` }}
                            >
                                <div className="p-3 rounded-full bg-brand-cyan/20 w-fit mb-4 group-hover:scale-110 transition-transform duration-300 icon-hover flex-shrink-0">
                                    <IconComponent className="w-6 h-6 text-brand-cyan-dark" />
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2 truncate">{action.title}</h3>
                                <p className="text-sm text-gray-600 line-clamp-2">{action.description}</p>
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    } else {

        return (
            <div className="mb-8 w-full max-w-full">
                <h2 className="text-xl font-bold text-gray-900 mb-4">Ações Rápidas</h2>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-full">
                    {actions.map((action, index) => {
                        const IconComponent = action.icon
                        return (
                            <button
                                key={action.id}
                                onClick={() => window.location.href = action.href}
                                className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 text-left group quick-action animate-fade-in-scale w-full max-w-full overflow-hidden" style={{ animationDelay: `${index * 150}ms` }}
                            >
                                <div className="p-3 rounded-full bg-brand-cyan/20 w-fit mb-4 group-hover:scale-110 transition-transform duration-300 icon-hover flex-shrink-0">
                                    <IconComponent className="w-6 h-6 text-brand-cyan-dark" />
                                </div>
                                <h3 className="text-lg font-semibold text-gray-900 mb-2 truncate">{action.title}</h3>
                                <p className="text-sm text-gray-600 line-clamp-2">{action.description}</p>
                            </button>
                        )
                    })}
                </div>
            </div>
        )
    }
}



export default CardActions